import { render, staticRenderFns } from "./TextAreaToggleExpand.vue?vue&type=template&id=8879ee38&scoped=true&"
import script from "./TextAreaToggleExpand.vue?vue&type=script&lang=ts&"
export * from "./TextAreaToggleExpand.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaToggleExpand.vue?vue&type=style&index=0&id=8879ee38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8879ee38",
  null
  
)

export default component.exports